export const UserType = {
  superAdmin: "super-admin",
  lead: "language-lead",
  editor: "language-editor",
  viewer: "language-viewer",
};
export const CloudURL ="https://us-central1-mandla-ddc22.cloudfunctions.net/api/"
